export const teamLeadActions = { 
    MOVE_TO_HIRED: "teamlead_selected",
    MOVE_TO_REHIRE: "teamlead_rehire",
    MOVE_TO_REJECTED: "teamlead_rejected",
}
